export default __webpack_public_path__ + "static/media/12-week-img.061cb4b9.png";